import { makeStyles } from 'tss-react/mui'
import { darkBackgroundSecondaryTextColor } from '../../../theme/theme'

export const useStyles = makeStyles<void, string>()((theme, props, classes) => ({
    parentContainer: {
        padding: theme.spacing(1, 2),
        "&:hover": {
            [`& .${classes.displayOnHover}` ]: {
                opacity: 1,
                pointerEvents: 'unset',
                zIndex: 1

            },
            [`& .${classes.hoveredButtons}` ]: {
                display: 'flex'

            },
            backgroundColor: theme.palette.background.default
        },
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'flex-start',
        justifyContent: 'center',
        gap: theme.spacing(0.5),
        borderWidth: theme.spacing(0.25),
        borderStyle: 'solid',
        borderColor: 'transparent'
    },
    firedContainer: {
        padding: theme.spacing(1, '10px'),
        display: 'flex',
        "&:hover": {
            [`& .${classes.displayOnHover}` ]: {
                opacity: 1,
                pointerEvents: 'unset',
                zIndex: 1
            },
            [`& .${classes.hoveredButtons}` ]: {
                display: 'flex'

            },
        },
        boxSizing: 'border-box',
        boxShadow: theme.palette.mode === 'light' ? `0 0 8px rgba(0,0,0,0.05), 2px 2px 8px rgba(0,0,0,0.05)` : '',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'flex-start',
        justifyContent: 'center',
        gap: theme.spacing(0.5),
        borderWidth: theme.spacing(0.2),
        borderRadius: theme.spacing(1),
        borderStyle: 'solid',
        borderColor: theme.palette.mode === 'dark' ? 'rgba(12, 12, 12, 0.4)' : theme.palette.divider,
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(50, 50, 50, 1)' : theme.palette.background.paper,
    },
    firedOrderContainer: {
        padding: theme.spacing(1, 2),
        display: 'flex',
        "&:hover": {
            [`& .${classes.displayOnHover}` ]: {
                opacity: 1,
                pointerEvents: 'unset',
                zIndex: 1
            },
            [`& .${classes.hoveredButtons}` ]: {
                display: 'flex'

            },
        },
        boxSizing: 'border-box',
        boxShadow: theme.palette.mode === 'light' ? `0 0 8px rgba(0,0,0,0.05), 2px 2px 8px rgba(0,0,0,0.05)` : '',
        flexDirection: 'row',
        width: '100%',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        gap: '8px',
        borderWidth: theme.spacing(0.2),
        borderRadius: theme.spacing(1),
        borderStyle: 'solid',
        borderColor: theme.palette.mode === 'dark' ? 'rgba(12, 12, 12, 0.4)' : theme.palette.divider,
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(50, 50, 50, 1)' : theme.palette.background.paper,
    },
    iconHover: {
        fontSize: 14,
        marginLeft: theme.spacing(1),
        '&:hover': {
            color: 'inherit'
        }
    },
    hoveredButton: {
        padding: theme.spacing(0.5),
        width: 22,
        height: 22,
    },
    displayOnHover: {
        opacity: 0,
        pointerEvents: 'none',
        zIndex: 1
    },
    topRight: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(2),
    },
    avatar: {
        width: 20,
        height: 20
    },
    alertName: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: '14px',
        fontWeight: 700,
        fontStyle: 'normal',
        lineHeight: '21px',
        minWidth: 0
    },
    alertMessage: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: '14px',
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '18px',
        minWidth: 0
    },
    dot: {
        fontSize: '14px',
        verticalAlign: 'middle',
    },
    hoveredIcon: {
        width: 18,
        height: 18,
    },
    tooltip: {
        padding: theme.spacing(1),
    },
    wrapOverflow: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        overflow: 'hidden',
    },
    fullWidth: {
        width: '100%'
    },
    hideOverflow: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    primaryBordered: {
        borderColor: theme.palette.primary.main
    },
    attributesContainer : {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    attributesChip: {
        display: 'flex',
        justifyContent: 'flex-start',
        p: 0,
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        zIndex: 1000,
        ':hover': {
            cursor: 'pointer'
        }
    },
    fullHeight: {
        height: '100%'
    },
    minW0: {
        minWidth: 0
    },
    verticalAlignMiddle: {
        verticalAlign: 'middle'
    },
    hoveredButtons: {
        justifyContent: 'space-between',
        minWidth: '30%',
        display: 'none',
        alignItems: 'center',
        flex: '1 1 0%',
        flexDirection: 'row'

    },
    cursorPointer: {
        cursor: 'pointer'
    },
    alignCenter: {
        alignItems: 'center'
    },
    tooltipCaption: {
        color: theme.palette.mode === 'light' ? darkBackgroundSecondaryTextColor : theme.palette.text.secondary
    },
    h22: {
        height: '22px'
    }
}))